import { Loader } from 'components/common/Loader';
import WimsicalError from 'components/common/WimsicalError/WimsicalError';
import { formatErrorMessage } from 'helpers/formatErrorMessage';
import { QueryErrorModel } from 'models/ErrorModel';
import { useGetBirstSSOTokenQuery } from 'redux/services/twittlebugs/sparingRequestsApi';

export const Reports = (): JSX.Element => {
  const { data, isLoading, isFetching, isError, error } = useGetBirstSSOTokenQuery();

  if (isLoading || isFetching) return <Loader loadingMessage="Loading Reports" />;

  if (isError) {
    const err = error as QueryErrorModel;

    return <WimsicalError title={formatErrorMessage(typeof err.status === 'number' ? err.status : 400)} subTitle={err?.data?.errorMessage ? err.data.errorMessage : ''} statusCode={err.status} />;
  }

  return (
    <div>
      <h1>Reports</h1>
      <iframe
        width={'100%'}
        height={800}
        title="birst"
        src={`https://login.bws.birst.com/SSO.aspx?BirstSSOToken=${data?.accessToken}
      &birst.module=newDashboards&birst.exportZoom=2&&amp;birst.embedded=true
      &birst.hideDashboardNavigation=false&birst.hideDashboardPrompts=false`}
      />
    </div>
  );
};
